import React from 'react'
import './Instragram.css'

const Instagram = () => {
  return (
    
       <div>
         <div class="instagram">
    <a href="https://www.instagram.com/" target="_blank">
    <i class="fab fa-instagram"></i><span>Instragram<br/><small></small></span>
    </a>
       </div>
    </div>
    
  )
}

export default Instagram
